import { ILink } from '@models/ILink';
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { Dispatch, SetStateAction } from 'react';
import LinksList from './LinksList';

interface Props {
  readonly links: ILink[];
  readonly title: string;
  readonly isOpen: boolean;
  readonly onSetOpenTitle: Dispatch<SetStateAction<string>>;
}

const LinksSection = ({ links, title, isOpen, onSetOpenTitle }: Props) => (
  <div className="flex flex-col">
    {title && (
      <button
        type="button"
        className={classNames(
          'body-two flex items-center justify-between text-left md:pointer-events-none md:text-grey-500',
          {
            'text-yellow': isOpen,
          }
        )}
        onClick={() => onSetOpenTitle(isOpen ? '' : title)}
        data-testid="CT-02-Footer-Link-Lists-Title"
        aria-label={title}
      >
        <span dangerouslySetInnerHTML={{ __html: title }} />
        <div className="relative flex items-center md:hidden">
          <span className="relative block h-0.5 w-3 bg-yellow-500" />
          <span
            className={classNames(
              'absolute block h-0.5 w-3 rotate-90 transform bg-yellow-500',
              { hidden: isOpen }
            )}
          />
        </div>
      </button>
    )}

    <div className="hidden md:block">
      <LinksList links={links} title={title} />
    </div>

    <div className="block md:hidden">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="overflow-hidden"
            initial={{ height: 0 }}
            animate={{ height: 'auto' }}
            exit={{ height: 0 }}
          >
            <LinksList links={links} title={title} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  </div>
);

export default LinksSection;
